import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.css'],
    standalone: false
})
export class ButtonComponent implements OnInit {

  @Input() buttonId: string = '';
  @Input() buttonClass: string = '';
  @Input() buttonType: 'button' | 'submit' | 'reset' = 'button';
  @Input() isDisabled: boolean = false;
  @Input() tooltipText: string = '';
  @Input() tooltipPosition: string = 'bottom';
  @Input() tooltipStyleClass :string = "tooltip-class";
  @Input() icon?: string | null = null;
  @Input() imageSrc?: string = '';
  @Input() imageAlt?: string = '';
  @Input() imageClass?: string = '';

  @Output() clickEvent = new EventEmitter<Event>();
  @Output() submitEvent = new EventEmitter<void>();

  ngOnInit(): void {
  }

  onClick(event?: Event) {
    this.clickEvent.emit(event);
  }

  onSubmit() {
    if (this.buttonType === 'submit') {
      this.submitEvent.emit();
    }
  }

}
